import { ButtonHTMLAttributes } from "react";

const variants = {
    primary: "bg-ink text-ink-inverse hover:bg-ink/90 border border-transparent",
    accent: "bg-accent text-white hover:bg-accent-hover border border-transparent",
    secondary: "bg-transparent text-ink border border-border-strong hover:bg-surface-sunken",
    ghost: "bg-transparent text-ink hover:bg-surface-sunken border border-transparent",
};

const sizes = {
    sm: "h-9 px-3 text-sm gap-1.5",
    md: "h-11 px-5 text-sm gap-2",
    lg: "h-12 px-6 text-base gap-2",
};

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
    variant?: keyof typeof variants;
    size?: keyof typeof sizes;
}

export function Button({ variant = "primary", size = "md", className = "", ...props }: ButtonProps) {
    return (
        <button
            className={`inline-flex items-center justify-center rounded-lg font-sans font-medium
                transition-colors duration-150 disabled:opacity-40 disabled:pointer-events-none
                focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-accent focus-visible:ring-offset-2
                ${variants[variant]} ${sizes[size]} ${className}`}
            {...props}
        />
    );
}
